import { useEffect } from 'react';
import type { AuctionInformation } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

type Options = {
  rawDataId: number | string;
};

export function useAuctionInformations({ rawDataId }: Options) {
  const auctionInformation = useAxios(
    (axios, baseConfig, { rawDataId }: Options) =>
      axios.request<AuctionInformation[]>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/uploads/additionalAuctionInformation/${rawDataId}`,
        method: 'GET',
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    auctionInformation.execute({ rawDataId });
    // oxlint-disable-next-line exhaustive-deps
  }, [rawDataId]);

  return auctionInformation;
}

export type AuctionInformationsRequest = ReturnType<
  typeof useAuctionInformations
>;
